module.exports = __webpack_public_path__ + "img/7cb5891.jpg";